import React from "react";
import LeagMainHead from "../../common/LeagMainHead";
import InfoPage from "../../football/league/InfoPage";
import LeagueWrapper from "../../football/league/LeagueWrapper";

const CricketTeamWidgetWrap = (props) => {
  const {
    dataId,
    dataType,
    head,
    data,
    headData,
    baseUrl,
    sport,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
    setDataType,
    setDataId,
    setHead,
    difference,
  } = props;

  const renderHeadWrap = (currentTab, children) =>
    head ? (
      <LeagMainHead
        id={dataId}
        headData={headData}
        baseUrl={baseUrl}
        sport={"cricket"}
        state="team"
        dataClient={dataClient}
        currentTab={currentTab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        widgetTitle={dataTitle}
      >
        {children}
      </LeagMainHead>
    ) : (
      children
    );

  switch (dataType) {
    case "cricket-team-info":
      return renderHeadWrap("info",
        <InfoPage
          id={dataId}
          sport={sport}
          data={data}
          loadCSS={loadCSS}
          baseUrl={baseUrl}
          setDataType={setDataType}
          setDataId={setDataId}
          setHead={setHead}
          dataClient={dataClient}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          matchType="team"
        />
      );

    case "cricket-team-upcoming":
      return renderHeadWrap("upcoming",
        <LeagueWrapper
          sport={sport}
          data={data?.data}
          loadCSS={loadCSS}
          baseUrl={baseUrl}
          dataClient={dataClient}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          matchType="team"
          difference={difference}
        />
      );

    case "cricket-team-results":
      return renderHeadWrap("results",
        <LeagueWrapper
          sport={sport}
          data={data?.data}
          loadCSS={loadCSS}
          baseUrl={baseUrl}
          dataClient={dataClient}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          matchType="team"
          difference={difference}
        />
      );

    default:
      return <h1>Cricket Team Widget Not Found!</h1>;
  }
};

export default CricketTeamWidgetWrap;
